import { shape, number } from 'prop-types';

const loadCount = shape({
  problemLoadCount: number,
  lateLoadCount: number,
  withinTwoHoursCount: number,
});

export default loadCount;
